define(
	'ProductLine.Sku.View.Site'
,	[
		'ProductLine.Sku.View'
	,	'product_line_sku.tpl'

	,	'Backbone'
	]
,	function (
		View
	,	product_line_sku_tpl

	,	Backbone
	)
{
	'use strict';
	_.extend(View.prototype, {
			getContext: _.wrap(View.prototype.getContext, function extendContext(fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					var self = this;

					var model = self.model;
					var item = self.model && self.model.get('item') ? self.model && self.model.get('item') : null;
					var extendedWarrantyAvailable = item && item.get('custitem_extendedwarranty') ? item.get('custitem_extendedwarranty') : false;
					return _.extend(context, {
							extendedWarrantyAvailable: extendedWarrantyAvailable
					});
			})
	});
});

